import React from "react";
import * as Yup from "yup";
import { useFormik } from "formik";
import "./styles.css";
import ChecklistAnswerModal from "./ChecklistAnswerModal";
import "./customStyles.css";

const Checklist = ({
  activeSite,
  setAnswers,
  answers,
  setChecklist,
  checklist,
}) => {
  const [selectedQuestion, setSelectedQuestion] = React.useState(null);
  const [showChecklistModal, setShowChecklistModal] = React.useState(false);

  const answersValidation = useFormik({
    enableReinitialize: true,
    initialValues: {
      answer: "",
    },
    validationSchema: Yup.object({
      answer: Yup.string().required("Please select Answer."),
    }),
    onSubmit: async (values) => {
      setAnswers((prev) => {
        const next = [...prev];

        next.push({
          site_checklist_id: selectedQuestion.id,
          site_checklist_name: selectedQuestion.question,
          answer: values.answer,
        });

        return next;
      });

      answersValidation.resetForm();
      toggleChecklistModal();
    },
  });

  const isSelected = (site_checklist_id) =>
    answers.some((item) => item.site_checklist_id === site_checklist_id);

  const answerHandler = (event, checklist) => {
    if (event.target.checked) {
      setSelectedQuestion(checklist);

      toggleChecklistModal();
    } else {
      const filteredAnswers = answers.filter(
        (item) => item.site_checklist_id !== checklist.id
      );
      setAnswers(filteredAnswers);
    }
  };

  const displayAnswer = (site_checklist_id) => {
    const filterAnswer = answers.find(
      (answer) => answer.site_checklist_id === site_checklist_id
    );

    return filterAnswer?.answer ? (
      <p style={{ fontSize: 14, marginLeft: 25, color: "#28a745" }}>
        {filterAnswer?.answer}
      </p>
    ) : (
      ""
    );
  };

  const toggleChecklistModal = () => {
    setShowChecklistModal(!showChecklistModal);
  };

  return (
    <React.Fragment>
      <div className="timeclock__checklist-container">
        <h3 className="mb-2">Appointed Checklist</h3>
        <ul>
          {checklist.length > 0 ? (
            checklist.map((item, index) => (
              <li key={index}>
                <label className="form-check-inline">
                  <input
                    type="checkbox"
                    className="mr-2 form-check-input"
                    checked={isSelected(item.id)}
                    onChange={(e) => {
                      answerHandler(e, item);
                    }}
                  />
                  {item.question}
                </label>
                {displayAnswer(item.id)}
              </li>
            ))
          ) : (
            <li>
              <p className="text-muted">No record found.</p>
            </li>
          )}
        </ul>
      </div>

      <ChecklistAnswerModal
        show={showChecklistModal}
        onCloseClick={toggleChecklistModal}
        validation={answersValidation}
        selectedQuestion={selectedQuestion}
      />
    </React.Fragment>
  );
};

export default Checklist;
